<template>
  <div id="app_content" class="admin ordinamento">
    <h1>Ordinamento</h1>
    <p>Seleziona l'entità:</p>
    <select name="entita" id="entita" v-model="entity" @change="getEntityList">
      <option value="macro">Macrofamiglie</option>
      <option value="family">Famiglie</option>
      <option value="micro">Microfamiglie</option>
      <option value="mod_art">Moduli - Articolo</option>

    </select>

    <p>Trascina le righe nell'ordine desiderato e clicca salva una volta finito.</p>
    <p v-if="entity === 'mod_art'">Per ordinare i singoli articoli clicca sul modulo articolo corrispondente</p>
    <button @click="sortSave">Salva ordine</button>
    <div class="tabella">
      <div class="intestazione">
        <div class="codice">Codice</div>
        <div class="descrizione">Descrizione</div>
        <div class="ordinamento">Ordinamento</div>
      </div>
      <draggable v-model="list" group="entita'" @start="drag=true" @end="drag=false">
        <div :class="'riga num-' + i" v-for="(li, i) in list" :key="i">
          <div v-if="entity === 'mod_art'" class="codice mod_art" @click="openModalModArt(li.codice)" >{{li.codice}}</div>
          <div v-else class="codice">{{li.codice}}</div>
          <div v-if="entity !== 'mod_art'" class="descrizione">{{li.descrizione}}</div>
          <div v-else class="descrizione">{{li.family.descrizione}} | {{li.category.descrizione}}</div>
          <div class="ordinamento">{{li.ordinamento}}</div>
        </div>
      </draggable>
    </div>
    <div v-if="openModal" class="modal-mod-art">
       <div class="corpo">
         <i class="chiudi-btn fa-solid fa-xmark" @click="openModal = false"></i>
         <h1>{{currentModArt}}</h1>
         <button @click="sortSaveArt">Salva</button>
         <div class="tabella">
           <div class="intestazione">
             <div class="codice">Codice</div>
             <div class="descrizione">Descrizione</div>
             <div class="ordinamento">Ordinamento</div>
           </div>
           <draggable v-model="list_art" group="entita'" @start="drag=true" @end="drag=false">
             <div :class="'riga num-' + i" v-for="(li, i) in list_art" :key="i">
               <div class="codice">{{li.cod_art}}</div>
               <div class="descrizione">{{li.des_art}}</div>
               <div class="ordinamento">{{li.ordinamento}}</div>
             </div>
           </draggable>
         </div>
       </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable,
  },
  name: "index",
  data(){
    return {
      entity:null,
      list: null,
      list_art: null,
      currentModArt:null,
      openModal: false,
    }
  },
  methods: {
    getEntityList() {
      this.list = null
      axios({
        method: 'get',
        url: window.location.origin + '/admin/ordinamento/list',
        params: {
          entity: this.entity
        }
      }).then(res => {
        this.list = res.data;
      }).catch(err => {
        console.log(err.response.data.message)
      })
    },
    sortSave(){
      let array = []
      this.list.forEach(el=>{
        array.push(el.codice)
      })
      axios({
        method: 'get',
        url: window.location.origin + '/admin/ordinamento/sortSave',
        params: {
          entity: this.entity,
          codici: array
        }
      }).then(()=>{
        this.getEntityList()
      }).catch(err => {
        console.log(err.response.data.message)})
    },
    sortSaveArt(){
      let array = []
      this.list_art.forEach(el=>{
        array.push(el.cod_art)
      })
      axios({
        method: 'get',
        url: window.location.origin + '/admin/ordinamento/sortSave',
        params: {
          entity: 'article',
          codici: array
        }
      }).then(() =>{
        this.openModalModArt(this.currentModArt)
          }
      ).catch(err => {
        console.log(err.response.data.message)})
    },
    openModalModArt(code){
      this.currentModArt = code
      axios({
        method: 'get',
        url: window.location.origin + '/admin/ordinamento/list',
        params: {
          entity: 'article',
          cod_art: code,
        }
      }).then(res => {
        this.list_art = res.data;
        this.openModal = true
      }).catch(err => {
        console.log(err.response.data.message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#app_content {
  h1 {
    text-transform: uppercase;
    font-size: 1.5rem;
    margin-bottom: 50px;
  }
  p {
    margin-bottom: 20px;
  }
  select {
    margin-bottom: 10px;
  }
  button {
    margin-bottom: 30px;
  }
  .tabella {
    width: 100%;
    border: .5px solid #000000;
    .intestazione {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #000000;
      background-color: #8d8d89;
    }
    .riga {
      cursor: grabbing;
      display: flex;
      align-items: center;
      width: 100%;
      border: 3px outset #ababab;
      &:active {
        border-style: inset;
        background-color: var(--greenb2b);
        .codice {
          color: black;
        }
      }
    }
    .codice {
      width: 20%;
      height: 100%;
      border-right: 1px solid #000000;
      padding-left: 10px;
      min-height: 35px;
      line-height: 35px;
      &.mod_art {
        color: var(--greenb2b);
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .descrizione {
      width: 60%;
      height: 100%;
      border-right: 1px solid #000000;
      padding-left: 10px;
      min-height: 35px;
      line-height: 35px;
    }
    .ordinamento {
      width: 20%;
      height: 100%;
      padding-left: 10px;
      min-height: 35px;
      line-height: 35px;
    }
  }
  .modal-mod-art {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,.9);
    z-index: 10;
    width: 100%;
    height: 100%;
    padding: 30px;
    .corpo {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-left: 50%;
      transform: translate(-50%);
      .chiudi-btn {
        position: absolute;
        right: 10px;
        top: 0;
        cursor: pointer;
        font-size: 2.5rem;
      }
      margin-top: 100px;
      background-color: #FFFFFF;
      width: 95%;
      padding: 50px 10px;
      .tabella {
        display: flex;
        flex-direction: column;
      }
      button {
        width: 200px;
      }
    }
  }
}
</style>
